import { Mixpanel } from "lib/mixpanel/mixpanel";
import { useUserData } from "lib/store/user";
import { type ReactNode, useEffect, useMemo } from "react";
import { ZephrContext } from "./context";
import { Tracker } from "./tracker";

type ZephrProps = {
  children: ReactNode;
  token: string;
};

export const ZephrTracker = ({ children, token }: ZephrProps) => {
  const tracker = useMemo(() => new Tracker(new Mixpanel(token)), [token]);
  const { userProfile } = useUserData();

  useEffect(() => {
    userProfile?.trackingId && tracker.init(userProfile);
  }, [userProfile, tracker]);

  return (
    <ZephrContext.Provider value={tracker}>{children}</ZephrContext.Provider>
  );
};
